module.exports = __webpack_public_path__ + "static/media/kp.770cb198.svg";